module.exports = __webpack_public_path__ + "1df862f322bc56c1a344401d271155b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/plans/campbell_soup.png
// module id = 1992
// module chunks = 0